<template>
  <div class='core'>
    <div class='layui-fluid'>
      <el-table
        border
        :data="pagerData.data"
        style="width: 100%"
        class="table-statistics-style"
      >
        <el-table-column
          prop="num"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="client_name"
          label="品牌"
          width="300">
        </el-table-column>
        <el-table-column
          prop="store_name"
          label="门店名称"
          width="300">
        </el-table-column>
        <el-table-column
          prop="store_manager_name"
          label="店长"
          width="120">
        </el-table-column>
        <el-table-column
          prop="address"
          label="地址"
          width="450">
        </el-table-column>
        <el-table-column
          prop="total_sort_num"
          label="故障数量"
          width="120">
        </el-table-column>
        <el-table-column
          prop="memo"
          label="备注"
          width="120">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 50]"
        :page-size="220"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagerData.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"

export default {
  name: 'totalSortStatistics',
  data () {
    return {
      pagerData: {
        data: [],
        total: 0
      },
      pageIndex: 0,
      pageSize: 10,
    }
  },
  props: {
    totalSortStatisticsList: {
      type: Array,
      default: ()=> {
        return [];
      }
    },
    rowCount: {
      type: Number,
      default: 0
    },
    endDate: {
      default: '',
      type: String
    },
    beginDate: {
      default: '',
      type: String
    },
  },
  mounted() {
    this.pagerData.data = this.totalSortStatisticsList
    this.pagerData.total = this.rowCount
  },
  watch: {
    totalSortStatisticsList(value) {
      this.pagerData.data = value
    },
    rowCount(value) {
      this.pagerData.total = value
    },
  },
  methods: {
    handleSizeChange(val) {
      // 每次切换条数  页数变为第一页
      this.pageSize = val
      this.pageIndex = 0
      // 调用父组件查询
      this.$emit('queryRepairTotalSortStatisticsList',this.beginDate, this.endDate, this.pageIndex, this.pageSize)
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      // 调用父组件查询
      this.$emit('queryRepairTotalSortStatisticsList',this.beginDate, this.endDate, this.pageIndex, this.pageSize)

    }
  }
}
</script>

<style scoped>
.table-statistics-style {
  height: calc(100vh - 286px);
}
</style>






// WEBPACK FOOTER //
// src/components/repairs/repairStatistics/totalSortStatistics.vue